import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';

export interface PlanoDisponivelReativacao {
  id: number;
  nome: string;
  preco: number;
  quantidadeUsuario: number; // 0 = ilimitado
  planoAnterior: boolean;
  cabeUsuariosAtivos: boolean;
}

export interface PlanosReativacaoResponse {
  planos: PlanoDisponivelReativacao[];
  usuariosAtivosAtuais: number;
  planoAnteriorId: number | null;
  planoAnteriorNome: string | null;
  situacao: 'SuspensaInadimplencia' | 'Cancelada' | string;
}

export interface ReativarAssinaturaRequest {
  planoId: number;
  numeroCartao: string;
  bandeiraCartao: string;
  validadeCartao: string; // MM/AA
  cvv: string;
  nomeTitular: string;
  cpfTitular: string;
}

export interface ReativarAssinaturaResponse {
  message: string;
  asaasSubscriptionId: string;
  usuariosAtivosAposReativacao: number;
  terasQueAtivarUsuariosManualmente: boolean;
}

@Injectable({ providedIn: 'root' })
export class ReativacaoService extends BaseService {
  private endpoint = environment.urlEdducaImobApi.concat('api/Reativacao/');

  constructor(private http: HttpClient) {
    super();
  }

  getPlanos(loader = true): Observable<PlanosReativacaoResponse> {
    return this.http.get<PlanosReativacaoResponse>(
      this.endpoint.concat('Planos'),
      { headers: this.getHeader(loader) }
    );
  }

  pagar(request: ReativarAssinaturaRequest, loader = true): Observable<ReativarAssinaturaResponse> {
    return this.http.post<ReativarAssinaturaResponse>(
      this.endpoint.concat('Pagar'),
      request,
      { headers: this.getHeader(loader) }
    );
  }
}
